// extracted by mini-css-extract-plugin
export default {"container":"_3Z5yN","header":"_2S3x8","notPGLayout":"_2PeVO","notPgLayout":"_2PeVO","withPadding":"BCAtH","menu":"_2PDrl"};